import React from 'react';

import CustomerCreate from './CustomerCreate';

const ConnectedCustomerCreate = () => <CustomerCreate />;

export default ConnectedCustomerCreate;
